import { defineComponent, computed } from 'vue';
// import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { UserOutlined, SettingOutlined, PoweroffOutlined, LogoutOutlined, KeyOutlined } from '@ant-design/icons-vue';
import UserManager from '@/user/UserManager'

export default defineComponent({
  components: {
    UserOutlined,
    SettingOutlined,
    PoweroffOutlined,
    LogoutOutlined,
    KeyOutlined
  },
  setup() {
    // const { t } = useI18n();
    const { state } = useStore();
    const route = useRoute();

    const selectedKeys = computed(() => [route.fullPath]);

    const logout = () => {
      UserManager.Logout()
    }

    const changePassword = () => {
      window.location.href = 'https://sso-v2.didaadmin.com/Account/manage/changepassword'
    }

    return () => (
      <a-dropdown
        trigger={['hover']}
        placement="bottom"
        v-slots={{
          overlay: () => (
            <a-menu slot="overlay" v-model={[selectedKeys.value, 'selectedKeys']}>
              {/* <a-menu-item disabled key="/personal/info">
                <UserOutlined /> {('PersonalCenter')}
              </a-menu-item>
              <a-menu-item disabled key="/personal/setting">
                <SettingOutlined /> {('PersonalSetting')}
              </a-menu-item>
              <a-menu-divider /> */}
              <a-menu-item key="/login" onClick={logout}>
                <LogoutOutlined />
                {(`  Logout`)}
              </a-menu-item>
              <a-menu-item key="/changePassword" onClick={changePassword}>
                <KeyOutlined />
                {(`  Change password`)}
              </a-menu-item>
            </a-menu>
          ),
        }}
      >
        <div class="head-item">
          <a-space>
            <a-avatar src="/avatar.jpg" size={22}></a-avatar>
            <span>{state.userInfo?.userName}</span>
          </a-space>
        </div>
      </a-dropdown>
    );
  },
});
